import React from "react";
import { Link } from "react-router-dom";
import "./UnLinkButton.css";
// import Breadcrumb from '../../../Layout/Breadcrumb/Breadcrumb';
// import Header from '../../../Layout/Header/Header';
// import Footer from '../../../Layout/Footer/Footer';
// import Nav from '../../../Layout/Nav/Nav';
// import LoginImage from '../../../Images/login.jpg';

function UnLinkButton(props) {
  //   const [iconButtonsStore, seticonButtonsStore] = useState(iconButtons);

  const UnLinkButton = [
    {
      id: 1,
      name: "add",
      button: (
        <button
          onClick={() => {
            props.trigerClick();
            props.modalStateAndValue &&
              props.modalStateAndValue.setState(
                props.modalStateAndValue.setStateValue
              );
          }}
          type="button"
          className="button-elmt button-elmt-add"
        >
          <div className="button-elmt-c-sec">
            <svg
              className="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </button>
      ),
    },

    {
      id: 2,
      name: "save",
      button: (
        <button
          onClick={props.trigerClick}
          type="button"
          className="button-elmt button-elmt-save"
        >
          <div className="button-elmt-c-sec">
            <svg
              className="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"></path>
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </button>
      ),
    },

    {
      id: 3,
      name: "close",
      button: (
        <button
          onClick={props.trigerClick}
          type="button"
          className="button-elmt button-elmt-close"
        >
          <div className="button-elmt-c-sec">
            <svg
              className="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </button>
      ),
    },

    {
      id: 4,
      name: "update",
      button: (
        <button
          onClick={props.trigerClick}
          type="button"
          className="button-elmt button-elmt-update"
        >
          <div className="button-elmt-c-sec">
            <svg
              class="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"></path>
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </button>
      ),
    },
  ];

  return UnLinkButton.filter((ibtn) => ibtn.name == props.btnname).map(
    (filteredIbtn) => <span key={filteredIbtn.id}>{filteredIbtn.button}</span>
  );
}
export default UnLinkButton;
